(() => {
  const grid = document.getElementById("cart-feature-grid");
  const summary = document.getElementById("cart-summary-and-blocks");
  if (!grid || !summary) return;
  const anchor = document.createComment("cart-feature-grid-anchor");
  grid.after(anchor);
  const mq = window.matchMedia("(max-width: 849px)");
  const placeGrid = ({ matches }) => {
    if (matches) {
      summary.append(grid);
    } else {
      anchor.after(grid);
    }
  };
  placeGrid(mq);
  mq.addEventListener("change", placeGrid);
})();
